import { useState, useLayoutEffect } from "react";
function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useLayoutEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      setWindowWidth(window.innerWidth);
    });
    resizeObserver.observe(document.documentElement);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  return windowWidth;
}
export {
  useWindowWidth
};
//# sourceMappingURL=use-window-width.js.map
